export default new (class Service {})();
